<template>
  <div class="bg-container">
    <div class="login">
      <div class="head">
        <van-popover v-model="showPopover" trigger="click" :actions="actions" @select="onSelect">
          <template #reference>
            <van-button type="primary" plain>{{languageText}}</van-button>
            <div></div>
          </template>
        </van-popover>
      </div>
      <div class="logo">
        <img src="/img/login/logo2.png" alt="">
      </div>
      <div class="panel">
        <div class="wrap">
          <div class="input_wrap">
            <van-icon name="contact-o" size="18" color="#3de0ff"></van-icon>
            <input type="text" :placeholder="$t('auth.username_place')" v-model="username">
          </div>
          <div class="input_wrap">
            <van-icon name="lock" size="18" color="#3de0ff"></van-icon>
            <input :placeholder="$t('auth.pwd_place')" v-model="password" :type="pwdType == 1 ? 'password' : 'text'">
            <van-icon :name="pwdType == 0 ? 'eye-o' : 'closed-eye'" color="#8e9bb8" size="20" @click="pwdType = pwdType == 1 ? 0 : 1"></van-icon>
          </div>
        </div>
        <div class="button" @click="doLogin()">{{$t("auth.login")}}</div>
        <div class="row" @click="toRegister">{{$t("auth.no_account")}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { LANGS, setLangManual } from "@/common/languages";
export default {
  model: {
    prop: "inputValue",
    event: "input",
  },
  props: {
    /**
     * 当前输入的值
     */
    inputValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      pwdType: 1,
      username: "",
      lang: 'en_us',
      password: this.inputValue,
      passwordType: "password",
      showPopover: false,
      languageText: '',
      actions: LANGS.map(item => ({ text: item.name, code: item.code })),
    };
  },
  mounted(){
    // localStorage.setItem("lang", 'ms_my');
    this.lang = localStorage.getItem("lang") || 'en_us';
    this.actions.map(item => {
      if(item.code === this.lang) {
        this.languageText = item.text
      }
    })
  },
  methods: {
    onSelect(e) {
      Toast.loading({
        duration: 200,
      });
      this.$i18n.locale = e.code;
      this.languageText = e.text;
      localStorage.setItem("lang", e.code);
      setLangManual();  // 手动选择优先，之后不再被 IP / 注册地区覆盖
      // if (this.source=='setting'){
      //   this.$router.push({path:'/'});
      // }else{
      //   this.$router.go(-1);
      // }
    },
    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    back() {
      return window.history.back();
    },
    toRegister() {
      this.$router.push("Register");
    },
    doLogin() {
      if (
        this.username === "" ||
        this.username === null ||
        this.username === undefined
      ) {
        this.$toast(this.$t("auth.username_place"));
        return false;
      }
      if (
        this.password === "" ||
        this.password === null ||
        this.password === undefined
      ) {
        this.$toast(this.$t("auth.pwd_place"));
        return false;
      }
      this.$http({
        url: "member_login",
        method: "post",
        data: { 
          username: this.username, 
          password: this.password,
          lang: this.lang
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data.id);
          this.$applyLoginLang(res.data.reg_lang); // 登录后按注册地区语言切换
          this.$router.push("Mine");
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
  created() {
    if (localStorage.getItem("token")) {
      return window.history.back();
    }
  },
};
</script>

<style lang='less' scoped>
@import '~@/assets/css/theme.less';

.bg-container {
  background: @bg-page;
  height: 100%;
}
.login {
  position: relative;
  // display: flex;
  // flex-direction: column;
  height: 100%;
  width: 100%;
  // padding: 4.4rem 0.9rem 1.5rem;
  background:
    radial-gradient(80% 42% at 0% 0%, rgba(122, 44, 255, 0.45), transparent 62%),
    radial-gradient(70% 36% at 100% 100%, rgba(61, 224, 255, 0.2), transparent 58%),
    linear-gradient(180deg, rgba(7, 11, 20, 0.92) 0%, rgba(7, 11, 20, 0.97) 100%),
    url('/public/img/login/bg2.png') no-repeat 50% / cover;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
    background-image:
      linear-gradient(rgba(61, 224, 255, 0.05) 1px, transparent 1px),
      linear-gradient(90deg, rgba(61, 224, 255, 0.05) 1px, transparent 1px);
    background-size: 1.8rem 1.8rem;
    mask-image: linear-gradient(180deg, #000 0%, transparent 78%);
  }
}

.logo {
  position: relative;
  z-index: 1;
  width: 9.4rem;
  margin: auto auto 1.5rem;
  img{
    width: 100%;
    filter: drop-shadow(0 0 0.7rem rgba(61, 224, 255, 0.55)) drop-shadow(0 0 1.4rem rgba(180, 77, 255, 0.4));
  }
}

.panel {
  position: relative;
  z-index: 1;
  width: 100%;
  margin: 0;
  padding: 1.25rem 1rem 1.15rem;
  border-radius: 0.55rem;
  background: rgba(10, 16, 32, 0.72);
  border: @glass-border;
  box-shadow: @shadow-soft, inset 0 1px 0 rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  &::before {
    content: '';
    position: absolute;
    left: 1.15rem;
    right: 1.15rem;
    top: 0;
    height: 2px;
    background: linear-gradient(90deg, transparent, @neon-blue, @neon-purple, @neon-pink, transparent);
    box-shadow: 0 0 0.7rem rgba(61, 224, 255, 0.65);
  }
}

.wrap{
  .input_wrap{
    width: 100%;
    height: 2.85rem;
    margin: 0 0 0.65rem;
    border-radius: 0.35rem;
    overflow: hidden;
    background: rgba(6, 10, 20, 0.72);
    border: 1px solid rgba(150, 180, 220, 0.2);
    border-left: 3px solid rgba(61, 224, 255, 0.75);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 0.9rem;
    &:focus-within {
      border-color: rgba(61, 224, 255, 0.55);
      border-left-color: @neon-pink;
      box-shadow: 0 0 0.8rem rgba(61, 224, 255, 0.18);
    }
    input{
      flex: 1;
      min-width: 0;
      height: 100%;
      border: none;
      background: none;
      outline: none;
      text-align: left;
      font-size: 0.95rem;
      padding-left: 0.7rem;
      color: @text-title;
      &::placeholder {
        color: @text-sub;
      }
    }
  }
}

.row {
  height: 2.55rem;
  line-height: 2.55rem;
  margin: 0.6rem 0 0;
  text-align: center;
  font-size: 0.92rem;
  font-weight: 500;
  color: @neon-blue;
  border: 1px solid rgba(61, 224, 255, 0.35);
  border-radius: 0.35rem;
  background: rgba(61, 224, 255, 0.04);
}

.button{
  width: 100%;
  background: @grad-primary;
  box-shadow: @shadow-pink;
  font-size: 1.05rem;
  font-weight: 600;
  letter-spacing: 0.14rem;
  color: #fff;
  text-align: center;
  height: 2.85rem;
  line-height: 2.85rem;
  border-radius: 0.35rem;
  margin: 0.15rem 0 0;
}
.head{
  padding: 0.9rem 0.9rem;
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  z-index: 10;
}
.van-button {
  height: 2rem;
  line-height: 2rem;
  padding: 0 0.75rem;
  font-size: 0.82rem;
  background: rgba(8, 14, 28, 0.72);
  border-color: rgba(61, 224, 255, 0.45);
  color: @text-title;
  border-radius: 0.28rem;
  box-shadow: 0 0 0.7rem rgba(61, 224, 255, 0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}
::v-deep .van-popover__action-text {
  font-size: 0.88rem;
}
</style>
